import {
  Checkbox,
  FormControl,
  Grid,
  Input,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { ApplyStyle as _s } from "../../../utils/ApplyStyle";
import { useStore } from "react-redux";
import { getNotificationTooltipAndColor } from "../../../types";
import { Theme247 } from "../../../styles/Theme247";

function NotificationTypesFilter(props) {
  const {
    setFilterNotificationTypes,
    FilterNotificationTypes,
    isFocused
  } = props;

  console.log(props,"propsssws")

  const useStyles = makeStyles()((theme) => ({
    filterStyle: {
      width: 190,
      marginLeft: theme.spacing(3),
    },
    itemcardGridSection: {
      ...theme.itemcardGridSection,
      marginBottom: 0,
    },
    itemcardGridItem: {
      ...theme.itemcardGridItem,
    },
    buttonContainer: {
      textAlign: "right",
    },
    smallCheckbox: {
      ...theme.multiselectCheckbox,
    },
  }));
  const { classes, cx } = useStyles(props, {
    props: props,
  });

  const i18n = useStore().getState().i18n;

  const renderNotificationTypesValues = (value) => {
    if (value.length > 1) {
      return i18n.select_multiple_n.replace("%s", value.length);
    } else if (value.length === 1) {
      return filterNotificationTypesValues.map((type) => {
        return type.value === value[0] ? type.label : "";
      });
    }
  };

  const filterNotificationTypesValues = [
    { code: 9999, value: "all", label: i18n.all_notificationtypes },
    ...[0, 1, 2, 6, 7, 8, 9, 10, 11, 12].map((number) => {
      return {
        code: number,
        value: number,
        label: getNotificationTooltipAndColor(number).tooltip,
      };
    }),
  ];

  const handleNotificationTypesChange = (event) => {
    setFilterNotificationTypes(event.target.value);
    window.blurAll();
    // ApplyFilters("TYPE", event.target.value);
  };

  return (
    <Grid item style={{ marginLeft: isFocused ? "0px" : "20px"}} className={isFocused ? "dnd_Filters_dialog" : "dnd_Filters"}>
      <FormControl
        variant="standard"
        className={cx(classes.filterStyle, _s(Theme247.noMargin.left))}
        fullWidth
      >
        <InputLabel
          id="label-notificationTypes"
          className={_s(Theme247.formControlLabel)}
        >
          {i18n.notificationtype}
        </InputLabel>
        <Select
          multiple
          labelId="label-notificationTypes"
          className="grouped-native-select"
          input={<Input />}
          onChange={handleNotificationTypesChange}
          renderValue={renderNotificationTypesValues}
          value={FilterNotificationTypes}
          MenuProps={{ keepMounted: true, disablePortal: true }}
          fullWidth
        >
          {filterNotificationTypesValues
            .filter((ar) => ar.type !== 6)
            ?.map((type, k) => {
              return (
                <MenuItem key={k} value={type.value}>
                  <Checkbox
                    key={k}
                    size="small"
                    className={classes.smallCheckbox}
                    checked={FilterNotificationTypes.includes(type.value)}
                  />
                  <span
                    style={{
                      color: getNotificationTooltipAndColor(type.code)?.color,
                    }}
                  >
                    {type.label}
                  </span>
                </MenuItem>
              );
            })}
        </Select>
      </FormControl>
    </Grid>
  );
}

export default NotificationTypesFilter;
